const cookie = document.querySelector('.cookie');

if(!!cookie) {
    const cookie_button = cookie.querySelector('.cookie__button');

    cookie_button.addEventListener('click', ()=>{
        cookie.classList.add('hide');

        document.cookie = 'cookie_confirmed=confirmed; path=/; max-age=2592000';
    });
}
